import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IContactUS } from "../../models/BaseModel";
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";

import { InputTextarea } from "primereact/inputtextarea";

const schema = yup.object({
    name: yup.string().required("Name is required*"),
    email: yup.string().required("Email is required*"),
    subject: yup.string().required("Subject is required*"),
    message: yup.string().required("Message is required*")
});

interface Iprops {
    singleData: IContactUS,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IContactUS>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);


    const saveToDB = async (body: IContactUS) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`ContactUs${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: IContactUS) {
        saveToDB(data);
    }



    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header="Add/Edit Contact Us" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={1} label="Name" control={control} name="name" error={errors.name?.message} />
                <JVInput column={2} label="Email" control={control} name="email" error={errors.email?.message} />
                <JVInput column={2} label="Subject" control={control} name="subject" error={errors.subject?.message}/>
                <Controller
                    name="message"
                    control={control}
                    render={({ field }) => (
                        <InputTextarea
                            value={field.value || ""}
                            onChange={(e) => field.onChange(e.target.value)}
                            onBlur={field.onBlur}
                            rows={5}
                            cols={20}
                        />
                    )}
                />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}